import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { OfferGroupTranslationsRequest } from '~client/model/admin/offer-group-translations-request';
import { ResponseEntity } from '~client/model/response-entity';

/**
 * Adds translations to an existing Offer Group
 * @param request
 */
export const performAddOfferGroupTranslations = (
  request: OfferGroupTranslationsRequest,
): Observable<ResponseEntity> =>
  apiClient.marketplaceAdminController.addOfferGroupTranslations$(request);



// WEBPACK FOOTER //
// ./interactor/offer-group/perform-add-offer-group-translations.ts